// extracted by mini-css-extract-plugin
export default {"title":"checkout_title__X10sI"};